import styled from 'styled-components';

export const StldPagination = styled.div`
    display: flex;
    justify-content: end;
    margin: 0.25rem;

    & div {
        color: #EE4B21;
        width: 24px;
        height: 24px;
        border: solid 1px #ccc;
        display: flex;
        justify-content: center;
        align-items: center;
    }


    .highlight-page{
        background-color: #EE4B21;
        color: white;
    }
`